import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {formatErrors} from "../../../constants";
import {clientUpdateAction} from "../../../actions/clientAction";
import {toast} from "react-toastify";
import {InputUserForm} from "../../../utils/input/InputUserForm";
import {Age} from "../../../utils/dateFormat/Age";

export function ClientAge({client, handleChange}) {
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setForm({
      birthday: client.birthday || '',
      children: client.children || ''
    });
  }, [client.birthday, client.children]);

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
  };

  const handleCancel = () => {
    if (edit === 'loading') {
      return;
    }
    setForm({
      birthday: client.birthday || '',
      children: client.children || ''
    });
    setEdit(false);
  };

  const handleSave = () => {
    if (edit === 'loading') {
      return;
    }
    setEdit('loading');
    dispatch(clientUpdateAction(client.id, form)).then(() => {
      setEdit(false);
      handleChange(form);
    }).catch(err => {
      setEdit(true);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <div className={"tabs__wrapper" + (edit ? " tabs__wrapper--edit" : "")}>
    {!edit && <React.Fragment>
      <span className="tabs__edit edit pointer" onClick={() => setEdit(true)}>Ред.</span>
      <div className="tabs__inner">
        <div className="tabs__heading">Возраст</div>
        {client.birthday && <div className="tabs__value"><Age date={client.birthday}/></div>}
        {!client.birthday && <div className="tabs__value">&mdash;</div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Дети</div>
        {client.children && <div className="tabs__value">{client.children}</div>}
        {!client.children && <div className="tabs__value">&mdash;</div>}
      </div>
    </React.Fragment>}
    {edit && form && <React.Fragment>
      <div className="tabs__inner">
        <div className="tabs__heading">Возраст</div>
        <div className="tabs__value">
          <InputUserForm type="date" value={form.birthday} name="birthday" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Дети</div>
        <div className="tabs__value">
          <InputUserForm type="text" value={form.children} name="children" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__buttons">
        <span className="tabs__btn tabs__btn--canceling btn pointer" onClick={handleCancel}>Отменить</span>
        <span className="tabs__btn tabs__btn--save btn pointer" onClick={handleSave}>Сохранить</span>
      </div>
    </React.Fragment>}
  </div>;
}
